import React, { useEffect, useState } from 'react';
import { Tag, X } from 'lucide-react';
import { DISCOUNT_CODE_WORDS } from '../components/discountCodeWords';
import type { CheckoutLanguage } from '../components/checkoutLabels';
import { noticeSeen, pendingNotice, takeSharedDiscount } from './sharedDiscount';

/** How long the notice stays before it goes by itself. */
const SHOWN_MS = 7000;

// Takes a shared link's code once, and says so for a few seconds, as Shopify does for a discount link.
export const SharedCodeNotice: React.FC<{ language: CheckoutLanguage | null }> = ({ language }) => {
  const [code, setCode] = useState<string | null>(null);
  // Hides the notice for good: this visit has seen it.
  const hide = () => { noticeSeen(); setCode(null); };
  useEffect(() => { takeSharedDiscount(); setCode(pendingNotice()); }, []);
  useEffect(() => {
    if (!code) return;
    const timer = window.setTimeout(hide, SHOWN_MS);
    return () => window.clearTimeout(timer);
  }, [code]);
  if (!code) return null;
  const words = DISCOUNT_CODE_WORDS[language ?? 'en'];
  return (
    <div className="xe-shared-code" role="status" dir="auto">
      <Tag size={16} aria-hidden />
      <span>{words.sharedNotice.replace('{code}', code)}</span>
      <button type="button" onClick={hide} aria-label={words.remove}><X size={16} aria-hidden /></button>
    </div>
  );
};
